import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgReverseRight = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 7H10a6 6 0 1 0 0 12h10m0-12-4-4m4 4-4 4"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgReverseRight)
export default ForwardRef
